$(document).ready(function () {
    $(".hover-label").inFieldLabels({ pollDuration: 200 });
});